import { render } from "./popupBase.vue?vue&type=template&id=3a98aa40&scoped=true"
import script from "./popupBase.vue?vue&type=script&lang=js"
export * from "./popupBase.vue?vue&type=script&lang=js"

import "./popupBase.vue?vue&type=style&index=0&id=3a98aa40&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a98aa40"]])

export default __exports__